<template>
  <div v-show="isVisible">
    <v-text-field
      :label="schema.label || schema.title"
      type="number"
      v-model="localValue"
      :placeholder="schema.placeholder"
      :rules="rules"
      :class="fieldClasses"
    />
  </div>
</template>

<script>
import GenericField from './GenericField';

export default {
  name: 'numberField',
  mixins: [GenericField],
};
</script>
